/**
 * Per-command flow / repo / diagram caps surfaced in the UI.
 *
 * Mirrors `packages/common_lib/src/common_lib/command_limits.py`. The Python
 * parity test `test__command_limits_parity` asserts these values match, so
 * bumping a cap requires editing both files (and the test will fail loudly if
 * they drift).
 */

// Doc generation degrades in quality and gets very slow past ~4 flows per
// request. Enforced at the API layer pre-LLM and surfaced as an inline error
// in `FlowNameSelector` so users get an explicit cap instead of a slow,
// low-quality 10-flow run.
export const MAX_FLOWS_TO_DOCUMENT = 4

export const MAX_MULTI_SELECT_REPOS = 8

export const MAX_SEQ_DIAGRAM_CNT = 10
